// extracted by mini-css-extract-plugin
export default {"select":"HX5s8","title":"wDVLL"};